import Vue from 'vue';
import App from './App';
import router from './router';

import 'babel-polyfill';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import preview from 'vue-photo-preview';
import 'vue-photo-preview/dist/skin.css';

import { pca, pcaa } from 'area-data';
import VueAreaLinkage from 'vue-area-linkage';
import 'vue-area-linkage/dist/index.css';

import animated from 'animate.css';

import axios from 'axios';
import Vuex from 'vuex';

import VueAwesomeSwiper from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css';

import store from './store/';
import VueLazyload from 'vue-lazyload';
import infiniteScroll from 'vue-infinite-scroll';
import 'font-awesome/css/font-awesome.css';
import Mixin from './mixins';
import Bus from 'src/vueBus';
import filters from './filters';
// import { enums, PcCookie, PcLockr, PcEncrypt } from 'utils/';
import './style/common.css';
import './style/elementUI.css';
import './style/style.css';
import './style.less';
import {
    Dialog,
    MessageBox,
    Message,
    Loading
} from 'element-ui';
Vue.use(preview);

Vue.use(animated);
Vue.prototype.$pca = pca;
Vue.prototype.$pcaa = pcaa;
Vue.use(VueAreaLinkage);

const components = [
  Dialog
];
components.map(component => {
  Vue.component(component.name, component);
});
Vue.prototype.$ELEMENT = { size: 'small' };
Vue.use(Loading.directive);
Vue.prototype.$pcLoading = Loading.service;
Vue.prototype.$pcMessageBox = MessageBox;
Vue.prototype.$pcMessage = Message;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$pcNProgress = NProgress;
Vue.prototype.$pcBus = Bus;
// Vue.prototype.$pcEnum = enums;
// Vue.prototype.$pcEncrypt = PcEncrypt;
// Vue.prototype.$pcLockr = PcLockr;
// Vue.prototype.$pcCookie = PcCookie;

Vue.prototype.$http = axios.create({
  timeout: 60000
});

if (process.env.NODE_ENV === 'production') {
  Vue.prototype.$http.defaults.baseURL = 'https://www.jdcai.com/bus';
}
// request拦截器
Vue.prototype.$http.interceptors.request.use(config => {
    // Do something before request is sent
    // if (store.getters.getAccessToken) {
    //     config.headers['Token'] = store.getters.getAccessToken; // 让每个请求携带token--['X-Token']为自定义key 请根据实际情况自行修改
    // }
  return config;
}, error => {
    // Do something with request error
  console.log(error); // for debug
  Promise.reject(error);
});

Vue.prototype.$http.interceptors.response.use((res) => {
  if (res.data.code === 200) {
    return res.data;
  } else {
    Message({
      message: res.data.message,
      type: 'warning',
      duration: 5 * 1000
    });
    return res.data;
  }
    // if (res.data.code === 10011039 || res.data.code === 10011040 || res.data.code === 10011041) {
    //     console.info('登录超时', res.data);
    //     // 验证token失败 || 解析header失败 || 页面已过期,请重新登录
    //     // store.dispatch('delete_user_info');
    //     // window.location.href = '/';
    //     return Promise.reject(res);
    // } else {
    //     store.dispatch('new_notice', {
    //         autoClose: true,
    //         content: res.data.message
    //     });
    //     return Promise.reject(res);
    // }
}, (error) => {
  let options = {
    autoClose: true,
    content: error.response.data.message
  };
  if (error.response) {
    console.log('error: ', error.response);
    if (error.response.status === 401) {
            // store.dispatch('delete_user_info');
            // 无权限

      Message({
        message: '登陆超时',
        type: 'error',
        duration: 5 * 1000
      });

      store.dispatch('delete_user_info').then(() => {
        router.push({ path: '/result/login' });
        location.reload();// In order to re-instantiate the vue-router object to avoid bugs
      });
            // window.location.href = '/';
    } else {
      Message({
        message: error.response.data.message,
        type: 'error',
        duration: 5 * 1000
      });
      return error.response.data;
    }
  } else {
    options.content = '接口请求失败或超时！请刷新重试';
  }
  store.dispatch('new_notice', options);
});

router.beforeEach((to, from, next) => {
  NProgress.start();
    // dom.style.display = 'none';
  console.log(4444444, to.path);
  if (to.path === '/result/login' || to.path == '/dashboard/index') {
    next();
    NProgress.done(); // if current page is dashboard will not trigger	afterEach hook, so manually handle it
  } else {
    store.dispatch('get_access_token', (res) => {
      if (res) {
        store.dispatch('GetUserInfo', res).then((response) => {
          next();
        }).catch(err => {
          next();
        });
                // next({ path: '/dashboard/index' })
                // window.location.href = store.getters.getRedirectUri;
      } else {
        NProgress.start();
        next();
      }
    });
  }
});
router.afterEach(transition => {
  let lists = document.getElementsByClassName('mouse-cover-canvas');
  for (var i = 0, j = lists.length; i < j; i++) {
    if (lists[i]) {
      lists[i].style.display = 'none';
    }
  }
  NProgress.done();
});

Vue.config.productionTip = false;

Vue.use(ElementUI);
Vue.use(Vuex);
Vue.use(VueAwesomeSwiper);

Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: '/static/loading-svg/loading-bars.svg',
  loading: '/static/loading-svg/loading-spinning-bubbles.svg',
  attempt: 2
});
Vue.use(infiniteScroll);
Vue.mixin(Mixin);

Object.keys(filters).forEach(k => Vue.filter(k, filters[k]));
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js